/*
 * Copyright (c) 2025 by PROS, Inc.  All Rights Reserved.
 * This software is the confidential and proprietary information of
 * PROS, Inc. ("Confidential Information").
 * You may not disclose such Confidential Information, and may only
 * use such Confidential Information in accordance with the terms of
 * the license agreement you entered into with PROS.
 */
/**
 * Multipart Json Responses.
 */
export const ResponsePartKind = {
    CHAT_UI_TEXT_OUTPUT: 'chat-ui-text-output',
    CHAT_UI_HIGHCHARTS_CHART: 'chat-ui-highcharts-chart',
};
/**
 * A user defined type guard to assert that the object is a ChatUiTextOutput one.
 */
export function isChatUiTextOutputResponsePart(responsePart) {
    return (typeof responsePart.type === 'string' &&
        responsePart.type ===
            ResponsePartKind.CHAT_UI_TEXT_OUTPUT);
}
/**
 * A user defined type guard to assert that the object is a ChatUiHighchartsChartResponsePart one.
 */
export function isChatUiHighchartsChartResponsePart(responsePart) {
    return (typeof responsePart.type ===
        'string' &&
        responsePart.type ===
            ResponsePartKind.CHAT_UI_HIGHCHARTS_CHART);
}
/**
 * A user defined type guard to assert that the object is a reference one.
 */
export function isReferenceResponsePart(responsePart) {
    return typeof responsePart.refId === 'string';
}
/**
 * A user defined type guard to assert that the object is an Event one.
 */
export function isEventResponsePart(responsePart) {
    return (typeof responsePart.type === 'string' &&
        responsePart.type.startsWith('event:'));
}
export const QueryStatus = {
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    PROCESSING: 'PROCESSING',
    QUEUED: 'QUEUED',
};
/**
 * A user defined type guard to assert that the object is a GetQueryStatusCompletedResponse one.
 */
export function isMultipartJsonResponse(response) {
    return (typeof response.multiPartJson ===
        'object');
}
/**
 * HITL (Human In The Loop).
 */
export const HitlStatus = {
    PROCESSING: 'PROCESSING',
    QUESTION: 'QUESTION',
    NO_QUESTION: 'NO_QUESTION',
};
/**
 * Feedback.
 */
export const FeedbackReaction = {
    POSITIVE: 'POSITIVE',
    NEGATIVE: 'NEGATIVE',
};
/**
 * Client Response.
 */
export const ClientResponseStatus = {
    SUCCESS: 'SUCCESS',
    UNCATEGORIZED_ERROR: 'UNCATEGORIZED_ERROR',
    INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
    BAD_REQUEST: 'BAD_REQUEST',
};
//# sourceMappingURL=model.js.map